export default "__VITE_ASSET__DRsNoiMV__"